/**
 * Created by methee on 9/11/17.
 */
/* eslint-disable react/forbid-prop-types, css-modules/no-unused-class, camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import Link from '../../components/Link';

import HotelType from '../../data/types/HotelType';

import s from './BreadCrumb.css';

const messages = defineMessages({
  home: {
    id: 'breadcrumb.home',
    defaultMessage: '##Home##',
    description: 'Breadcrumb home',
  },
  ourHotels: {
    id: 'our_hotels.our_hotels',
    defaultMessage: '##Our Hotels##',
    description: 'Our Hotels header text',
  },
  fullName: {
    id: 'hotel.full_name',
    defaultMessage: '##Red Planet {hotelName}##',
    description: 'Hotel full name. Do not translate or remove {hotelName}',
  },
});

class BreadCrumb extends React.Component {
  render() {
    const {
      hotel,
      locations,
      query: { check_in, check_out },
    } = this.props;
    let country = null;
    let city = null;
    locations.forEach(c => {
      c.children.forEach(ct => {
        ct.children.forEach(area => {
          if (area.id === hotel.location.id) {
            country = c;
            city = ct;
          }
        });
      });
    });
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        <ul>
          <li>
            <Link to="/">
              <FormattedMessage {...messages.home} />
            </Link>
          </li>
          <li>
            <span className={s.separator}>\</span>
          </li>
          <li>
            <Link to="/hotels">
              <FormattedMessage {...messages.ourHotels} />
            </Link>
          </li>
          <li>
            <span className={s.separator}>\</span>
          </li>
          {country && (
            <li>
              <Link
                to={`/country/${country.name_en}${
                  check_in && check_out
                    ? `?check_in=${check_in}&check_out=${check_out}`
                    : ''
                }`}
              >
                {country.name}
              </Link>
            </li>
          )}
          <li>
            <span className={s.separator}>\</span>
          </li>
          {city && (
            <li>
              <Link to={`/city/${city.name_en}`}>{city.name}</Link>
            </li>
          )}
          <li>
            <span className={s.separator}>\</span>
          </li>
          <li className={s.selected}>
            <FormattedMessage
              {...messages.fullName}
              values={{
                hotelName: hotel.name,
              }}
            />
          </li>
        </ul>
      </div>
    );
  }
}

BreadCrumb.propTypes = {
  hotel: HotelType.shape(),
  locations: PropTypes.array,
  query: PropTypes.shape({
    check_in: PropTypes.string,
    check_out: PropTypes.string,
    rooms: PropTypes.string,
    adults: PropTypes.string,
    children: PropTypes.string,
    code: PropTypes.string,
  }),
};

BreadCrumb.contextTypes = {
  intl: intlShape,
};

BreadCrumb.defaultProps = {
  hotel: null,
  locations: [],
  query: {
    check_in: moment().format('YYYY-MM-DD'),
    check_out: moment()
      .add(1, 'd')
      .format('YYYY-MM-DD'),
    rooms: 1,
    adults: 2,
    children: 0,
    code: '',
  },
};

export default withStyles(s)(BreadCrumb);
